import React from 'react'
import palette from 'core-system/Themes/palette'
import SummaryContainerBox from 'features/Programs/Summary/components/SummaryContainerBox'
import SummaryOptions from 'features/Programs/Summary/components/SummaryOptions'
import QTF from 'core-system/Icons/Sidebar/QTF'
import SummaryBudget from 'features/Programs/Summary/components/SummaryBudget'

interface QtfSummaryProps {
  benefits: {
    transit: boolean
    parking: boolean
  }
  employerContributions: {
    transit: number
    parking: number
  }
  maxAllocationLimit: {
    transit: number | null
    parking: number | null
  }
  irsTaxLimit: number
}

const QtfSummary = ({
  benefits = {
    transit: false,
    parking: false,
  },
  employerContributions = {
    transit: 0,
    parking: 0,
  },
  maxAllocationLimit = {
    transit: null,
    parking: null,
  },
  irsTaxLimit = 0,
}: QtfSummaryProps) => {
  // Use irsTaxLimit if maxAllocationLimit is null (not set)
  const effectiveTransitMaxAllocation =
    maxAllocationLimit.transit === null
      ? irsTaxLimit
      : maxAllocationLimit.transit
  const effectiveParkingMaxAllocation =
    maxAllocationLimit.parking === null
      ? irsTaxLimit
      : maxAllocationLimit.parking

  return (
    <SummaryContainerBox title='Pre-tax Commuter Benefits'>
      <SummaryOptions
        icon={<QTF color={palette.secondary.purple600} />}
        activeOptions={[
          {
            type: 'transit',
            activeMerchantIds: [],
            active: benefits.transit,
          },
          {
            type: 'parking',
            activeMerchantIds: [],
            active: benefits.parking,
          },
        ]}
      />
      <SummaryBudget
        title='Budget'
        lines={[
          {
            title: 'Transit Contribution',
            value: employerContributions.transit,
          },
          {
            title: 'Parking Contribution',
            value: employerContributions.parking,
          },
          {
            title: 'Transit Max Allocation',
            value: effectiveTransitMaxAllocation,
          },
          {
            title: 'Parking Max Allocation',
            value: effectiveParkingMaxAllocation,
          },
        ]}
      />
    </SummaryContainerBox>
  )
}

export default React.memo(QtfSummary)
